<template>
  <div class="self-business">
    <div class="top-banner">
      自 考 业 务
    </div>
    <!-- 8大核心变量 -->
    <div class="self-business-policy">
      <div class="g-box">
        <div class="top-title">8大核心变量</div>
        <div class="sub-title">{{ policyInfo.title }}</div>
        <div class="content">
          <img :src="policyInfo.image" alt="" class="img" />
        </div>
      </div>
    </div>
    <!-- 双师教学理论 -->
    <div class="self-business-theory">
      <div class="g-box">
        <div class="top-title">双师教学理论</div>
        <div class="sub-title">{{ theoryInfo.title }}</div>
        <div class="content">
          <img :src="theoryInfo.image" alt="" class="img" />
        </div>
      </div>
    </div>
    <!-- 双师学习法 -->
    <div class="self-business-function">
      <div class="g-box">
        <div class="content">
          <div class="fun-le">
            <img :src="onlineInfo.image" alt="" class="img" />
            <div class="con">
              <div class="title">线上+线下结合“双师”教学模式</div>
              <div class="line"></div>
              <div class="items">
                <div
                  class="item"
                  v-for="(item, i) in onlineInfo.content"
                  :key="i"
                >
                  <div class="dot"></div>
                  <div class="txt">{{ item }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="fun-ri">
            <img :src="modalInfo.image" alt="" class="img" />
            <div class="con">
              <div class="title">Habit学习法</div>
              <div class="sub-tit">{{ modalInfo.title }}</div>
              <div class="line"></div>
              <div class="items">
                <div
                  class="item"
                  v-for="(item, i) in modalInfo.content"
                  :key="i"
                >
                  <div class="dot"></div>
                  <div class="txt">{{ item }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 自问自答 -->
    <div class="self-business-oneself">
      <div class="g-box">
        <div class="top-title">自问自答</div>
        <div class="sub-title">{{ oneselfInfo.title }}</div>
        <div class="content">
          <img :src="oneselfInfo.image" alt="" class="img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";
export default {
  mixins: [pageMain_mx],
  data() {
    return {
      bannerList: [],
      policyInfo: {},
      onlineInfo: {},
      modalInfo: {},
      oneselfInfo: {},
      theoryInfo: {}
    };
  },
  components: {},
  async mounted() {
    // 8大核心变量
    const menuId = this.getMenuId("自考业务-vip课程服务-8大核心变量");
    if (menuId) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId
      });
      this.policyInfo = data[0] || {};
    }
    // 双师教学理论
    const menuId2 = this.getMenuId("自考业务-vip课程服务-双师教学理论");
    if (menuId2) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId2
      });
      this.theoryInfo = data[0] || {};
    }
    // 线上线下
    const menuId3 = this.getMenuId(
      "自考业务-vip课程服务-线上线下结合双师教学模式"
    );
    if (menuId3) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId3
      });
      data[0].content = data[0].content.split(",");
      this.onlineInfo = data[0] || {};
    }
    // 教学模式
    const menuId4 = this.getMenuId("自考业务-vip课程服务-Habit学习法");
    if (menuId4) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId4
      });
      data[0].content = data[0].content.split(",");
      this.modalInfo = data[0] || {};
    }
    // 自问自答
    const menuId5 = this.getMenuId("自考业务-vip课程服务-自考问答");
    if (menuId5) {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 1000,
        menuId: menuId5
      });
      this.oneselfInfo = data[0] || {};
    }
  },
  methods: {}
};
</script>
<style lang="less">
.self-business {
  .top-banner {
    padding-top: 80px;
    text-align: center;
    height: 280px;
    background: url("../../assets/img/self-bg.png") no-repeat center top;
    background-size: cover;
    box-sizing: border-box;
    font-size: 60px;
    color: #fff;
    line-height: 84px;
    letter-spacing: 8px;
  }
  //  8大核心变量
  &-policy {
    padding: 80px 0 70px 0;
    .top-title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #173758;
      letter-spacing: 4px;
    }
    .sub-title {
      margin-top: 10px;
      text-align: center;
      font-size: 16px;
      color: #173758;
    }
    .content {
      margin-top: 40px;
      width: 1200px;
      height: 480px;
      .img {
        width: 1200px;
        height: 480px;
      }
    }
  }
  //  双师教学理论
  &-theory {
    padding: 80px 0 70px 0;
    background: #f1f1f1;

    .top-title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #bc1e1d;
      letter-spacing: 4px;
    }
    .sub-title {
      margin-top: 10px;
      text-align: center;
      font-size: 16px;
      color: #272727;
    }
    .content {
      margin-top: 60px;
      width: 1200px;
      height: 520px;
      .img {
        width: 1200px;
        height: 520px;
      }
    }
  }
  // 双师学习法
  &-function {
    padding-top: 80px;
    height: 840px;
    background-color: #1e3f67;
    box-sizing: border-box;
    .content {
      display: flex;
      .fun-le {
        position: relative;
        padding: 50px;
        margin-right: 20px;
        width: 480px;
        height: 680px;
        box-sizing: border-box;
        .img {
          position: absolute;
          left: 0;
          top: 0;
          width: 480px;
          height: 680px;
        }
        .con {
          position: relative;
          z-index: 11;
          .title {
            font-size: 36px;
            font-weight: bold;
            color: #fff;
            line-height: 50px;
          }
          .line {
            margin-top: 30px;
            width: 60px;
            height: 5px;
            background: #ffffff;
          }
          .items {
            margin-top: 30px;
            display: flex;
            flex-wrap: wrap;
            .item {
              margin-top: 30px;
              display: flex;
              align-items: center;
              width: 180px;
              .dot {
                width: 16px;
                height: 16px;
                background: #00b68a;
                border: 5px solid #ffffff;
                border-radius: 50%;
              }
              .txt {
                width: 150px;
                padding-left: 10px;
                font-size: 22px;
                font-weight: 500;
                color: #fff;
              }
            }
          }
        }
      }
      .fun-ri {
        position: relative;
        padding: 50px;
        width: 700px;
        height: 680px;
        box-sizing: border-box;
        .img {
          position: absolute;
          left: 0;
          top: 0;
          width: 700px;
          height: 680px;
        }
        .con {
          position: relative;
          z-index: 11;
          .title {
            font-size: 36px;
            font-weight: bold;
            color: #173758;
            line-height: 50px;
          }
          .sub-tit {
            padding-top: 10px;
            font-size: 14px;
            font-weight: 600;
            color: #173758;
            line-height: 20px;
          }
          .line {
            margin-top: 30px;
            width: 60px;
            height: 5px;
            background: #173758;
          }
          .items {
            margin-top: 30px;
            display: flex;
            flex-wrap: wrap;
            .item {
              margin-top: 30px;
              display: flex;
              align-items: center;
              width: 280px;
              .dot {
                width: 16px;
                height: 16px;
                border: 5px solid #00b68a;
                border-radius: 50%;
              }
              .txt {
                width: 250px;
                padding-left: 10px;
                font-size: 22px;
                font-weight: 500;
                color: #173758;
              }
            }
          }
        }
      }
    }
  }
  // 自问自答
  &-oneself {
    padding: 80px 0 70px 0;
    .top-title {
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: #173758;
      letter-spacing: 4px;
    }
    .sub-title {
      margin-top: 10px;
      text-align: center;
      font-size: 16px;
      color: #173758;
    }
    .content {
      margin-top: 40px;
      width: 1200px;
      height: 480px;
      .img {
        width: 1200px;
        height: 480px;
      }
    }
  }
}
</style>
